import Layout from "../Layout/Layout";
import { useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { setPageTitle } from "../utils/titleUtils";
import confetti from "canvas-confetti";

export default function LafzOfParadiseResult() {
  const location = useLocation();
  const { t } = useTranslation();

  const winnersByLikes = [
    {
      name: "Sarika Nandrajog",
      category: "Hindi",
      prize: "₹5000",
      tag: "Winner by Likes",
    },
    {
      name: "Apeksha Kadam",
      category: "English",
      prize: "₹3000",
      tag: "Runner Up by Likes",
    },
  ];

  const judgesChoice = [
    {
      name: "Ishu Kumar",
      category: "Hindi",
      prize: "₹5000",
      tag: "Judge's Choice Winner",
    },
    {
      name: "Sourin Kar",
      category: "English",
      prize: "₹3000",
      tag: "Judge's Choice Runner Up",
    },
  ];

  useEffect(() => {
    setPageTitle(location.pathname);

    // Confetti animation
    const colors = ["#bb0000", "#ffffff"];
    const intervalId = setInterval(() => {
      confetti({
        particleCount: 200,
        angle: 60,
        spread: 90,
        origin: { x: 0 },
        colors: colors,
      });
      confetti({
        particleCount: 200,
        angle: 120,
        spread: 90,
        origin: { x: 1 },
        colors: colors,
      });
    }, 1000);

    setTimeout(() => {
      clearInterval(intervalId);
      confetti.reset();
    }, 5000);

    return () => {
      clearInterval(intervalId);
      confetti.reset();
    };
  }, [location.pathname]);

  return (
    <Layout>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "var(--color-background)",
        }}
      >
        <Root>
          <div className="result-container">
            <div className="header">
              <img
                alt="background"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/b4d1e3b8cc628fbeb8b1d964eed8e1be23c1768583a24241c2d0966049529503?"
              />
              <span className="title" style={{ color: "white" }}>
                Lafz Of Paradise Winners
              </span>
            </div>

            <h2 className="winner-title">Winners By Likes</h2>
            {winnersByLikes.map((winner, index) => (
              <div className="winner-container" key={`likes-${index}`}>
                {/* <h1 className="winner-title">
                  {winner.tag}
                </h1> */}
                <h1 className="winner-name">{winner.name}</h1>
                <p className="winner-tag">Category: {winner.category}</p>
                {/* <p className="winner-prize" style={{ color: "white" }}>
                  Prize Money: {winner.prize}
                </p> */}
              </div>
            ))}

            <h2 className="winner-title">Judge's Choice</h2>
            {judgesChoice.map((winner, index) => (
              <div className="winner-container" key={`judge-${index}`}>
                {/* <h1 className="winner-title">
                  {winner.tag}
                </h1> */}
                <h1 className="winner-name">{winner.name}</h1>
                <p className="winner-tag">Category: {winner.category}</p>
                {/* <p className="winner-prize" style={{ color: "white" }}>
                  Prize Money: {winner.prize}
                </p> */}
              </div>
            ))}

            <div className="winner-container">
              <h1 className="winner-title">Thank You :)</h1>
              <p className="info">
                We thank the public for the overwhelming participation in making
                the Lafz Of Paradise Poetry contest a grand success!
              </p>
              <h1 className="contest-name">
                Look out for our next engagement soon
              </h1>
            </div>
          </div>
        </Root>
      </div>
    </Layout>
  );
}

const Root = styled.div`
  min-height: 100vh;
  height: auto;
  background-color: var(--color-background);
  color: var(--color-text-tertiary, var(--color-text));
  display: flex;
  max-width: 1300px;
  width: 100%;

  .category-heading {
    color: var(--color-text-tertiary, var(--color-text));
    font-size: 35px;
    text-align: center;
    margin-top: 20px;

    @media (min-width: 350px) and (max-width: 600px) {
      font-size: 25px;
    }
  }

  .title {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: var(--color-text-tertiary, var(--color-text));
    font-size: 32px;
    font-weight: bold;

    @media (max-width: 768px) {
      font-size: 24px;
    }
    @media (max-width: 480px) {
      font-size: 18px;
    }
  }

  .winner-tag {
    text-align: center;
    align-items: center;
    font-size: 18px;
    color: var(--color-text-tertiary, var(--color-text));

    @media (max-width: 768px) {
      font-size: 16px;
    }
    @media (max-width: 480px) {
      font-size: 14px;
    }
  }

  .winner-prize {
    text-align: center;
    align-items: center;
    font-size: 18px;
    color: var(--color-text-tertiary, var(--color-text));

    @media (max-width: 768px) {
      font-size: 16px;
    }
    @media (max-width: 480px) {
      font-size: 14px;
    }
  }

  .contest-name {
    font-size: 20px;
    text-align: center;
    color: var(--color-text-tertiary, var(--color-text));

    @media (max-width: 768px) {
      font-size: 18px;
    }
    @media (max-width: 480px) {
      font-size: 14px;
    }
  }

  .winner-name {
    text-align: center;
    color: var(--color-text-tertiary, var(--color-text));
    font-size: 35px;
    margin: 10px 0;

    @media (max-width: 768px) {
      font-size: 28px;
    }
    @media (max-width: 480px) {
      font-size: 24px;
    }
  }
  .winner-container {
    padding: 15px 20px;
    width: 100%;
    max-width: 600px;
  }

  .info {
    font-size: 20px;
    text-align: center;
    color: var(--color-text-tertiary, var(--color-text));

    @media (max-width: 768px) {
      font-size: 16px;
    }
    @media (max-width: 480px) {
      font-size: 14px;
    }
  }

  .winner-title {
    color: #b20101;
    font-size: 45px;
    text-align: center;

    @media (max-width: 768px) {
      font-size: 32px;
    }
    @media (max-width: 480px) {
      font-size: 28px;
    }
  }

  .header {
    position: relative;
    width: 80%;
    max-width: 500px;
    max-height: 240px;

    img {
      width: 100%;
      height: auto;
    }

    @media (min-width: 350px) and (max-width: 600px) {
      max-height: 130px;
      max-width: 300px;
    }
  }

  .result-container {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
  }
`;
